import { useContext } from 'react';
import { NotificationContext } from '../context';
export var useNotification = function () {
    var context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};
